import makeStyles from '@mui/styles/makeStyles';

export const useAutocompleteSelectInputStyles = makeStyles(
  {
    wrapper: { width: 300 },
  },
  { name: 'autocomplete-select-input' }
);
